import { IndexTable } from 'components/ControlledTable';
import { ReactElement } from 'react';
import { CampaignsView, StageIndicators, viewFilterMap } from './types';
import { stages } from './stages';
import invariant from 'tiny-invariant';
import { CompanyField } from 'modules/core/company/components';
import { TextField } from '@ff-it/form';

type StageContainerProps = {
  view: CampaignsView;
  stage: keyof StageIndicators;
};

const tableProps = { size: 'xs' } as const;
export function StageContainer({ view, stage }: StageContainerProps): ReactElement {
  const config = stages[stage];
  invariant('url' in config);
  const { queryParms, columns, url } = config;

  return (
    <IndexTable<any>
      // no sticky filters
      storageKey={null}
      filterFields={
        <>
          <TextField name="search" placeholder="Search.." size="sm" />
          <CompanyField
            name="related_client"
            placeholder="Client or payer"
            className="ml-1"
            simple
            size="sm"
            includeBranches={true}
          />
        </>
      }
      url={url}
      columns={columns}
      pageSize={15}
      queryParams={{ view: viewFilterMap[view], ...queryParms }}
      tableProps={tableProps}
    />
  );
}
